export default {"src":"/_next/static/media/elment0.1a449049.svg","height":62,"width":91,"blurWidth":0,"blurHeight":0};